import React from "react";
import Select from "react-select";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Toggle from "react-toggle";

import { Button, ButtonGroup, Toast } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faThumbsUp, faThumbsDown, faArrowAltCircleUp, faArrowAltCircleDown } from "@fortawesome/free-solid-svg-icons";

import numeral from "numeral";

import { LineInput } from "components/Inputs/LineInput";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import PieChart from "components/Project/PieChart";
import TinyBarChart from "components/Project/TinyBarChart";
import PredictionDriverToolTip from "components/Project/PredictionDriverToolTip";

import ImpactSlider from "components/Optimizer/ImpactSlider";
import CompareScenario from "components/Project/CompareScenario";

import RunPlotContainer from "containers/RunPlot/RunPlot";
import RunFrontierContainer from "containers/FrontierSliders/RunFrontier";
import AdvancedCostsContainer from "containers/CreateWizard/Costs/AdvancedCosts";

import { checkValueWarning, getWarningMessage } from "containers/Setup/reducer";
import { AIBLE_VIEW_TYPE, isSameSetup } from "containers/Project/reducer";

import ProjectHelp from "containers/UnifiedProject/Help/ProjectHelp";
import ProjectHelpItem from "components/UnifiedProject/Help/ProjectHelpItem";

import PurpleDataIcon from "images/PurpleDataIcon.svg";
import PurpleFlagIcon from "images/PurpleFlagIcon.svg";

import styles from "./style.module.css";

export default class EmptyOptimize extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isHammer: false,
      isHelpClosed: false,
      isDrivers: true
    };
  }

  getIsOverallSegment() {
    const { project, optimized } = this.props;

    return (
      optimized &&
      optimized.innerSegment &&
      optimized.innerSegment.conditions.length === 0 &&
      optimized.innerSegment.job &&
      optimized.innerSegment.job.job_id === optimized.innerId &&
      project &&
      project.segments &&
      project.segments.length > 1
    );
  }

  renderAssumptions() {
    const {
      id,
      setup,
      blueprint,
      optimizer,
      optimized,
      isContinuous,
      customMappings,
      toggleCustomMapping,
      modelGroups,
      updateBaselineCustomValue,
      updateCustomValue,
      updateDrilldownValue,
      canEditAssumptions,
      updateConversionGain,
      updateConversionCost,
      updateConversionSaved,
      updateConversionMissed,
      updateBaselineConversionGain,
      updateBaselineConversionCost,
      updateBaselineConversionMissed,
      updateBaselineConversionSaved
    } = this.props;

    if (setup === undefined || Object.keys(setup).length === 0) {
      return <div />;
    }

    const isOverallSegment = this.getIsOverallSegment();

    const retId = optimized && optimized.innerId !== undefined ? optimized.innerId : id;

    const hasCustomValues =
      optimized &&
      optimized.setup &&
      optimized.setup.customValues &&
      Object.keys(optimized.setup.customValues).length > 0;

    const showCustomValues = hasCustomValues;

    return isOverallSegment ? (
      <div>
        <div className={styles.shareHeader}>
          <div className={styles.costSectionOne} style={{ paddingLeft: "0px" }}>
            {"Assumptions"}
          </div>
          <div className={styles.costSectionTwo}>{"Distribution"}</div>
          <div className={styles.costSectionThree} style={{ paddingRight: "0px" }}>
            {"Average"}
          </div>
        </div>
        {showCustomValues ? (
          <div
            className={styles.oItemBotContent}
            style={{
              marginTop: "0px"
            }}
          >
            <div className={styles.aholder}>
              {Object.keys(optimized.setup.customValues).map((c, i) => {
                const bpDesc =
                  optimized &&
                  optimized.blueprint &&
                  optimized.blueprint &&
                  optimized.blueprint.wizard &&
                  optimized.blueprint.wizard.customFields &&
                  optimized.blueprint.wizard.customFields[c] &&
                  optimized.blueprint.wizard.customFields[c].desc
                    ? optimized.blueprint.wizard.customFields[c].desc
                    : c;

                return (
                  <div key={i} className={styles.assumptionItem}>
                    <div className={styles.costSectionOne} title={bpDesc}>
                      {c}
                    </div>
                    <div className={styles.costSectionTwo}>
                      <ImpactSlider
                        impacts={modelGroups.drilldownValues.map((v) => ({
                          value: v.setup.customValues[c],
                          drilldownValue: v.value,
                          runId: v.runId,
                          color: v.color
                        }))}
                        currentImpact={optimized.setup.customValues[c]}
                        drilldownValue={optimizer.drilldownValue}
                        updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                      />
                    </div>
                    <div className={styles.costSectionThree}>
                      {optimized.setup.customValues[c] !== undefined
                        ? Number(optimized.setup.customValues[c]).toFixed(2)
                        : ""}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ) : (
          <div>
            {modelGroups && modelGroups.drilldownValues && (
              <div
                className={styles.oItemBotContent}
                style={{
                  marginTop: "0px"
                }}
              >
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.truePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionGain,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionGain}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionGain !== undefined
                      ? Number(optimized.setup.conversionGain).toFixed(2)
                      : ""}
                  </div>
                </div>
                <div className={styles.assumptionItem}>
                  <div className={styles.costSectionOne}>{optimized.setup.falsePositiveLabel}</div>
                  <div className={styles.costSectionTwo}>
                    <ImpactSlider
                      impacts={modelGroups.drilldownValues.map((v) => ({
                        value: v.setup.conversionCost,
                        drilldownValue: v.value,
                        runId: v.runId,
                        color: v.color
                      }))}
                      currentImpact={optimized.setup.conversionCost}
                      drilldownValue={optimizer.drilldownValue}
                      updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                    />
                  </div>
                  <div className={styles.costSectionThree}>
                    {optimized.setup.conversionCost !== undefined
                      ? Number(optimized.setup.conversionCost).toFixed(2)
                      : ""}
                  </div>
                </div>
                {!isContinuous ? (
                  <React.Fragment>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.trueNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionSaved,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionSaved}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionSaved !== undefined
                          ? Number(optimized.setup.conversionSaved).toFixed(2)
                          : ""}
                      </div>
                    </div>
                    <div className={styles.assumptionItem}>
                      <div className={styles.costSectionOne}>{optimized.setup.falseNegativeLabel}</div>
                      <div className={styles.costSectionTwo}>
                        <ImpactSlider
                          impacts={modelGroups.drilldownValues.map((v) => ({
                            value: v.setup.conversionGain,
                            drilldownValue: v.value,
                            runId: v.runId,
                            color: v.color
                          }))}
                          currentImpact={optimized.setup.conversionMissed}
                          drilldownValue={optimizer.drilldownValue}
                          updateDrilldownValue={(runId, name) => updateDrilldownValue(runId, name)}
                        />
                      </div>
                      <div className={styles.costSectionThree}>
                        {optimized.setup.conversionMissed !== undefined
                          ? Number(optimized.setup.conversionMissed).toFixed(2)
                          : ""}
                      </div>
                    </div>
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        )}
      </div>
    ) : (
      <div>
        {optimized ? (
          <div className={styles.aHeader}>
            <div style={{ width: "50%" }}>{"Assumptions"}</div>
            <div style={{ width: "50%" }}>{"Scenario"}</div>
          </div>
        ) : (
          <div className={styles.aHeader}>
            <div style={{ width: "50%" }}>{"Assumptions"}</div>
            <div style={{ width: "50%" }}>{"Scenario"}</div>
          </div>
        )}
        <div className={styles.aHolder}>
          {Object.keys(setup.customValues).map((v, i) => {
            const bpDesc =
              blueprint &&
              blueprint &&
              blueprint.wizard &&
              blueprint.wizard.customFields &&
              blueprint.wizard.customFields[v] &&
              blueprint.wizard.customFields[v].desc
                ? blueprint.wizard.customFields[v].desc
                : v;

            const currMapping = customMappings && customMappings[v];

            return (
              <React.Fragment key={v + i}>
                <div className={styles.assumptionEditItem}>
                  <div
                    className={styles.costEditThirdsOne}
                    title={bpDesc}
                    style={optimized === undefined ? { width: "50%" } : {}}
                  >
                    {v}
                  </div>
                  {/*
									<div
										className={styles.costEditThirdsTwo}
										style={
											optimized === undefined
												? { width: "50%" }
												: {}
										}
									>
										<div className={styles.cFieldInput}>
											<LineInput
												isMediumBox
												onChange={(val) =>
													updateBaselineCustomValue(
														retId,
														setup.blueprintId,
														v,
														val
													)
												}
												value={
													setup.baselineCustomValues &&
													setup.baselineCustomValues[
														v
													] !== undefined
														? setup
																.baselineCustomValues[
																v
														  ]
														: setup.customValues[v]
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
									</div>
									*/}
                  <div className={styles.costEditThirdsThree}>
                    <div className={styles.cFieldInput}>
                      <LineInput
                        isMediumBox
                        onChange={(val) => updateCustomValue(retId, setup.blueprintId, v, val)}
                        value={setup.customValues[v]}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                </div>
              </React.Fragment>
            );
          })}

          {Object.keys(setup.customValues).length === 0 ? (
            <div>
              <div className={styles.assumptionEditItem}>
                <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                  {setup.truePositiveLabel}
                </div>
                {/*
								<div
									className={styles.costEditThirdsTwo}
									style={
										optimized === undefined
											? { width: "50%" }
											: {}
									}
								>
									<LineInput
										isMediumBox
										value={
											setup.baselineConversionGain !==
											undefined
												? setup.baselineConversionGain
												: setup.conversionGain
										}
										onChange={(val) =>
											updateBaselineConversionGain(
												retId,
												val
											)
										}
										style={{ color: "#4B495B" }}
									/>
								</div>
								*/}
                <div className={styles.costEditThirdsThree}>
                  <LineInput
                    isMediumBox
                    value={setup.conversionGain}
                    onChange={(val) => updateConversionGain(retId, val)}
                    style={{ color: "#4B495B" }}
                  />
                </div>
              </div>
              <div className={styles.assumptionEditItem}>
                <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                  {setup.falsePositiveLabel}
                </div>
                {/*
								<div
									className={styles.costEditThirdsTwo}
									style={
										optimized === undefined
											? { width: "50%" }
											: {}
									}
								>
									<LineInput
										isMediumBox
										value={
											setup.baselineConversionCost !==
											undefined
												? setup.baselineConversionCost
												: setup.conversionCost
										}
										onChange={(val) =>
											updateBaselineConversionCost(
												retId,
												val
											)
										}
										style={{ color: "#4B495B" }}
									/>
								</div>
								*/}

                <div className={styles.costEditThirdsThree}>
                  <LineInput
                    isMediumBox
                    value={setup.conversionCost}
                    onChange={(val) => updateConversionCost(retId, val)}
                    style={{ color: "#4B495B" }}
                  />
                </div>
              </div>
              {!isContinuous ? (
                <React.Fragment>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.trueNegativeLabel}
                    </div>
                    {/*
										<div
											className={styles.costEditThirdsTwo}
											style={
												optimized === undefined
													? { width: "50%" }
													: {}
											}
										>
											<LineInput
												isMediumBox
												value={
													setup.baselineConversionSaved !==
													undefined
														? setup.baselineConversionSaved
														: setup.conversionSaved
												}
												onChange={(val) =>
													updateBaselineConversionSaved(
														retId,
														val
													)
												}
												style={{ color: "#4B495B" }}
											/>
										</div>
										*/}

                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionSaved}
                        onChange={(val) => updateConversionSaved(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                  <div className={styles.assumptionEditItem}>
                    <div className={styles.costEditThirdsOne} style={optimized === undefined ? { width: "50%" } : {}}>
                      {setup.falseNegativeLabel}
                    </div>
                    {/*
									<div
										className={styles.costEditThirdsTwo}
										style={
											optimized === undefined
												? { width: "50%" }
												: {}
										}
									>
										<LineInput
											isMediumBox
											value={
												setup.baselineConversionMissed !==
												undefined
													? setup.baselineConversionMissed
													: setup.conversionMissed
											}
											onChange={(val) =>
												updateBaselineConversionMissed(
													retId,
													val
												)
											}
											style={{ color: "#4B495B" }}
										/>
									</div>
									*/}

                    <div className={styles.costEditThirdsThree}>
                      <LineInput
                        isMediumBox
                        value={setup.conversionMissed}
                        onChange={(val) => updateConversionMissed(retId, val)}
                        style={{ color: "#4B495B" }}
                      />
                    </div>
                  </div>
                </React.Fragment>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }

  renderProgress(label) {
    const { optimized } = this.props;

    return (
      <div className={styles.eLight}>
        <div className={styles.lFlex}>
          <div className={styles.eCircle} />
          {optimized && optimized.isCreating ? "Finding Optimal " + label : "Optimization Not Started"}
        </div>
        <div className={styles.eLightBar} />
      </div>
    );
  }

  renderMix() {
    const { project, createSplits, optimized, optimizer, modelGroups } = this.props;
    const { isCreating } = this.state;

    const splitOptions =
      optimized && optimized.dataset
        ? Object.keys(optimized.dataset.fields)
            .filter((f) => optimized.dataset.fields[f].type === "categorical" && f !== optimized.dataset.outcome)
            .filter((f) =>
              optimized && optimized.setup && optimized.setup.ignored && optimized.setup.ignored[f] ? false : true
            )
            .map((f) => ({
              label: optimized.dataset.fields[f].label,

              value: optimized.dataset.fields[f].label
            }))
        : [];

    const drilldownValues = (modelGroups && modelGroups.drilldownValues && modelGroups.drilldownValues) || [];

    let drilldownSlice = undefined;

    for (let value of drilldownValues) {
      if (
        value.value != "Overall" &&
        (optimizer.drilldownValue == "Overall" || value.value === optimizer.drilldownValue)
      ) {
        drilldownSlice = value;
        break;
      }
    }

    const otherSlices = drilldownSlice
      ? drilldownValues.filter((v) => v && v.column && v.column == drilldownSlice.column && v.column !== "Overall")
      : undefined;

    let loadingSplits = false;

    otherSlices &&
      otherSlices.forEach((v) => {
        if (isNaN(v.optimalPct)) {
          loadingSplits = true;
        }
      });

    const darkSelectStyle = {
      option: (provided, state) => ({
        ...provided,
        background: state.isFocused ? "#512f77" : "#362e30",
        color: "white !important"
      }),
      control: (provided, state) => ({
        ...provided,
        background: "#362e44",
        border: "1px solid #828282",
        color: "white !important"
        // none of react-select's styles are passed to <Control />
      }),
      singleValue: (provided, state) => ({
        ...provided,
        color: "white"
      }),
      menuList: (provided, state) => ({
        ...provided,
        paddingTop: "0px",
        paddingBottom: "0px"
      })
    };

    return (
      <div className={styles.mixHolder} style={{ overflow: "visible" }}>
        {project && project.segments && project.segments.length === 1 && isCreating !== true ? (
          <div className={styles.splitFieldHolder}>
            <div className={styles.oItemBotHeader} style={{ textAlign: "center" }}>
              {"Split on Field"}
            </div>
            <div className={styles.splitField}>
              <Select options={splitOptions} ref="splitOne" styles={darkSelectStyle} />
            </div>
            <Button
              onClick={() => {
                this.setState({ isCreating: true });
                setTimeout(() => this.setState({ isCreating: false }), 5000);
                createSplits(
                  this.refs["splitOne"].state.value !== null ? this.refs["splitOne"].state.value.value : undefined
                );
              }}
              style={{ whiteSpace: "nowrap" }}
              isDark
            >
              {"Create Subgroups"}
            </Button>
          </div>
        ) : loadingSplits || isCreating ? (
          <div className={styles.smallLoader} style={{ padding: "2vw" }}>
            <LoadingIndicator style={{ marginTop: "-20px" }} color={"#868595"} />
            <div style={{ fontWeight: "300", marginTop: "-10px" }}>{"Training AI Models"}</div>
          </div>
        ) : (
          <div>
            <div className={styles.pieHolder}>
              <PieChart
                secondaryColors
                pData={
                  otherSlices
                    ? otherSlices.map((s) => ({
                        name: s.value,
                        runId: s.runId,
                        value: Math.round(s.optimalPct),
                        color: s.color
                      }))
                    : []
                }
                onClick={(runId, name) => updateDrilldownValue(runId, name)}
                unit={optimized.unitLabelShort}
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  parseValueName(name) {
    if (name.includes("more than ") && name.includes(" to ")) {
      return name.replace("more than", ">");
    }
    return name;
  }

  renderDrivers(topDrivers, count = 10, showValues = false) {
    const { updateModelFeedback, username } = this.props;

    const feedbackCount =
      topDrivers && topDrivers.bestModel && topDrivers.segment && topDrivers.segment.roles
        ? topDrivers.segment.roles.reduce(
            (a, b) =>
              a +
              (b &&
              b.preferences &&
              b.preferences.feedback &&
              b.preferences.feedback[topDrivers.bestModel.id] !== undefined
                ? Number(b.preferences.feedback[topDrivers.bestModel.id])
                : 0),
            0
          )
        : 0;

    return topDrivers === undefined ? (
      <div />
    ) : (
      <div style={{ marginBottom: "20px" }} key={topDrivers.drilldownValue}>
        <div className={styles.dHeader} style={{ fontWeight: "bold", background: topDrivers.color }}>
          {topDrivers.drilldownValue}
          <div className={styles.dFeedback}>
            <ButtonGroup>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, true)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsUp} />
              </Button>
              <Button
                onClick={
                  topDrivers.bestModel && topDrivers.bestModel.id !== undefined
                    ? () => updateModelFeedback(topDrivers.runId, topDrivers.bestModel.id, false)
                    : () => {}
                }
                style={{ padding: "5px" }}
              >
                <FontAwesomeIcon icon={faThumbsDown} />
              </Button>
            </ButtonGroup>
            <div className={styles.dNumber}>{(feedbackCount > 0 ? "+" : "") + feedbackCount}</div>
          </div>
        </div>
        {topDrivers && topDrivers.columnDrivers === undefined ? (
          <LoadingIndicator style={{ margin: "0px", marginBottom: "20px" }} />
        ) : (
          <div />
        )}
        {topDrivers &&
          topDrivers.columnDrivers &&
          topDrivers.columnDrivers
            .filter((m, i) => i < count)
            .map((m, i) => (
              <div className={styles.driverWrapper + " " + (showValues ? styles.hasValues : "")} key={i + m.field}>
                <div className={styles.driverTitle + " " + (showValues ? "" : styles.hideValues)}>{m.field}</div>
                {showValues ? (
                  <React.Fragment>
                    {m.maxName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.increase}>
                          <FontAwesomeIcon
                            style={{
                              marginRight: "10px"
                            }}
                            icon={faArrowAltCircleUp}
                          />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.maxName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                    {m.minName !== undefined ? (
                      <div className={styles.driverItem}>
                        <span className={styles.botDelta + " " + styles.decrease}>
                          <FontAwesomeIcon
                            style={{
                              marginRight: "10px"
                            }}
                            icon={faArrowAltCircleDown}
                          />
                        </span>
                        <div>
                          <div>{this.parseValueName(m.minName)}</div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </React.Fragment>
                ) : (
                  ""
                )}
              </div>
            ))}
      </div>
    );
  }

  renderIsContinuous() {
    const {
      id,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      optimized,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      setMaxBudget,
      setMinBudget,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      history,
      isEditBlueprint
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const underPredictLabel = setup.underPredictAction ? setup.underPredictAction : "Underestimate Cost";

    const overPredictLabel = setup.overPredictAction ? setup.overPredictAction : "Overestimate Cost";

    const pursued = Number(setup.truePositive) + Number(setup.falsePositive);
    const notPursued = Number(setup.trueNegative) + Number(setup.falseNegative);
    const total = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    return (
      <div
        className={styles.emptyOptimize}
        style={optimized && optimized.isCreating === false ? { paddingBottom: "200px" } : {}}
      >
        <div className={styles.emptyTop}>
          <ProjectHelp
            title={
              isEditBlueprint
                ? "Editing Blueprint: Business Cost Benefits and Labels"
                : optimized
                  ? "Optimize Business Impact by Adjusting Business Assumptions"
                  : "Add Baseline Business Assumptions to Optimize Business Impact"
            }
            isDark
            onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
            noBot
          >
            {isEditBlueprint !== true ? (
              <React.Fragment>
                <ProjectHelpItem isDark type={"targetGrey"}>
                  {"After Training the AI Aible will show the recommended resourcing, " +
                    "mix, and revenue that optimizes your profit and compares it to the baseline."}
                </ProjectHelpItem>
                <ProjectHelpItem isDark type={"rocketGrey"}>
                  {"You will be able to keep changing these assumptions even after training the AI."}
                </ProjectHelpItem>
              </React.Fragment>
            ) : (
              ""
            )}
          </ProjectHelp>
          <div className={styles.eBoxHolder}>
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimized " + underPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is the amount of the underestimate times" + " the total number of underestimated houses."}
                </div>
                <div className={styles.eLightLarge}>{numeral(optimized.underEstimate).format("0.0a")}</div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimizing " + underPredictLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(underPredictLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline " + underPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is your Business Assumptions Costs (the total cost " +
                    "per opportunity) times the Total Opportunities " +
                    "you expect to pursue."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimized " + overPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This is the amount of the overestimate times the " + "total number of overestimated houses."}
                </div>
                <div className={styles.eLightLarge}>{numeral(optimized.overEstimate).format("0.0a")}</div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimizing " + overPredictLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(overPredictLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline " + overPredictLabel}</div>
                <div className={styles.eSubDark}>
                  {"This uses your Business Assumption Benefits (expected revenue " +
                    "per opportunitiy) times your Total Expected Win Count."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
            {optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Optimized Error Cost"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of your total underestimate and overestimate costs."}
                </div>
                <div className={styles.eLightLarge}>
                  {numeral(optimized.overEstimate + optimized.underEstimate).format("0.0a")}
                </div>
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Error Cost"}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress("Error Cost")}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Error Cost"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the unique businesss circumstances you defined" +
                    " in the Costs/Benefits and Expected Win Count across all" +
                    " potential opportunities."}
                </div>
                <div className={styles.eDarkLarge}>{""}</div>
              </div>
            )}
          </div>
        </div>
        {false && isEditBlueprint ? (
          this.renderEditBlueprintBot()
        ) : (
          <div className={styles.emptyBot}>
            <div className={styles.eBotHeader}>
              <div className={styles.eBotHeaderItem} style={{ minWidth: "50%" }}>
                {"Business Assumptions"}
              </div>
              <div
                className={styles.eBotHeaderItem}
                style={{
                  minWidth: "calc(50% - 100px)",
                  marginRight: "20px"
                }}
              >
                {"Optimal AI Model"}
                {isOverallSegment !== true && id !== "new" && (
                  <ButtonGroup>
                    <Button onClick={() => this.setState({ isDrivers: true })} active={this.state.isDrivers === true}>
                      {"Drivers"}
                    </Button>
                    <Button onClick={() => this.setState({ isDrivers: false })} active={this.state.isDrivers === false}>
                      {"Charts"}
                    </Button>
                  </ButtonGroup>
                )}
              </div>
            </div>
            <div className={styles.eBotBody}>
              <div className={styles.eBotItem} style={{ minWidth: "50%" }}>
                {this.renderAssumptions()}
              </div>
              <div
                className={styles.eBotItem}
                style={{
                  minWidth: "calc(50% - 100px)",
                  marginRight: "20px"
                }}
              >
                {optimized && optimized.isCreating === false ? (
                  isOverallSegment || isDrivers ? (
                    <div>
                      <div className={styles.aHeader} style={{ marginBottom: "10px" }}>
                        {"Key Drivers"}
                        <PredictionDriverToolTip />
                      </div>
                      <div className={styles.nItemBotContent} style={{ overflow: "auto" }}>
                        {isOverallSegment
                          ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                          : this.renderDrivers(
                              (modelGroups.topDrivers || []).find((driver) => driver.runId === optimized.innerId),
                              5,
                              true
                            )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div className={styles.mBold}>
                        <span className={styles.spanLabel}>{"Optimal Model:"}</span>
                        <span>{model ? model.label : "..."}</span>
                      </div>
                      ""
                      <div className={styles.mRunFrontier}>
                        <RunFrontierContainer id={runId} projectId={id} />
                      </div>
                      <div
                        className={styles.runPlot}
                        style={{
                          height: this.state.isHelpClosed ? "37vh" : "30vh"
                        }}
                      >
                        {
                          <RunPlotContainer
                            id={runId}
                            isMiniOptimize
                            projectId={project ? project.id : undefined}
                            forceEnableBts
                            hideFrontier
                          />
                        }
                      </div>
                    </div>
                  )
                ) : (
                  <div className={styles.eBotBox}>
                    <img src={PurpleFlagIcon} className={styles.eIcon} />
                    <div className={styles.eBotBoxBold}>
                      {"Once the AI has been trained this section will " +
                        "display the model that best fits your use case."}
                    </div>
                    <div>
                      {"The optimal model will be based on the cost, benefit, and" +
                        " data assumptions you defined in the first two sections."}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  getBaselines() {
    const { id, setup, runId } = this.props;

    const truePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.truePositive)
        : Number(setup.truePositive);
    const falsePositive =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falsePositive)
        : Number(setup.falsePositive);
    const trueNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.trueNegative)
        : Number(setup.trueNegative);
    const falseNegative =
      setup.isRealityHammer && setup.baselineCounts
        ? Number(setup.baselineCounts.falseNegative)
        : Number(setup.falseNegative);

    const pursued = truePositive + falsePositive;
    const notPursued = trueNegative + falseNegative;

    const baselineTotal = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const bPositives = truePositive + falseNegative;
    const bNegatives = falsePositive + trueNegative;

    const baselinePositives = truePositive + falseNegative;
    const baselineNegatives = falsePositive + trueNegative;

    const total = positives + negatives;

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const baselineTotalWinRate = ((bPositives / (bPositives + bNegatives)) * 100).toFixed(2);

    return {
      baselineWinRate: baselineTotalWinRate,
      baselineTotal: baselineTotal
    };
  }

  renderEditBlueprintBot() {
    const { setup, project, blueprintId, runId } = this.props;

    return (
      <div className={styles.emptyBot}>
        <div className={styles.eBotHeader}>
          <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(50% - 40px)" }}>
            {"Edit Business Assumptions"}
          </div>
          <div
            className={styles.eBotHeaderItem}
            style={{
              minWidth: "calc(50% - 40px)",
              marginRight: "20px"
            }}
          >
            {"Custom Functions"}
          </div>
        </div>
        <div className={styles.eBotBody}>
          <div className={styles.eBotBlueprint} style={{ minWidth: "100%" }}>
            <AdvancedCostsContainer
              id={runId}
              runId={runId}
              blueprintId={setup && setup.blueprintId ? setup.blueprintId : "newBlueprint"}
              projectId={project ? project.id : undefined}
              isOptimizer
            />
          </div>
        </div>
      </div>
    );
  }

  render() {
    const {
      id,
      approvedScenario,
      isContinuous,
      currentSpend,
      currentRevenue,
      currentProfit,
      setup,
      isEditBlueprint,
      optimized,
      optimizer,
      isRealityHammer,
      project,
      modelGroups,
      runId,
      model,
      setMaxBudget,
      setMinBudget,
      updateScaledTotal,
      updateOutcomePercentage,
      updateIsRealityHammer,
      updateAdvancedCostLabel,
      updateAdvancedRevenueLabel,
      updateAdvancedProfitLabel,
      history
    } = this.props;

    const { isHammer, isCompare, isDrivers } = this.state;

    const transactionLabel = setup.transactionLabel ? setup.transactionLabel : "Opportunities";

    const truePositiveLabel = setup.truePositiveLabel ? setup.truePositiveLabel : "True Positive";

    const outcomeLabel =
      setup.outcomeLabel == undefined
        ? setup.success && setup.success.label !== undefined
          ? setup.success.label
          : truePositiveLabel
        : setup.outcomeLabel;

    const pursued = Number(setup.truePositive) + Number(setup.falsePositive);
    const notPursued = Number(setup.trueNegative) + Number(setup.falseNegative);
    const total = pursued + notPursued;

    const positives = Number(setup.truePositive) + Number(setup.falseNegative);
    const negatives = Number(setup.falsePositive) + Number(setup.trueNegative);

    const totalWinRate = ((positives / (positives + negatives)) * 100).toFixed(2);

    const minBudget =
      project &&
      project.settings.segmentMinBudgets &&
      project.settings.segmentMinBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMinBudgets[optimized.segmentId]
        : undefined;

    const maxBudget =
      project &&
      project.settings.segmentMaxBudgets &&
      project.settings.segmentMaxBudgets[optimized.segmentId] !== undefined
        ? project.settings.segmentMaxBudgets[optimized.segmentId]
        : undefined;

    const isOverallSegment = this.getIsOverallSegment();

    const retIsContinuous = isContinuous || (optimized && optimized.underEstimate !== undefined);

    const mSubGroup =
      optimizer &&
      modelGroups &&
      optimizer.drilldownValue &&
      modelGroups.drilldownValues &&
      modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue).length > 0
        ? modelGroups.drilldownValues.filter((d) => d.value === optimizer.drilldownValue)[0]
        : undefined;

    const unitType = setup.unitType !== undefined ? setup.unitType : "$";

    const isSkipped =
      approvedScenario &&
      optimized &&
      isSameSetup(approvedScenario.data, optimized.setup) &&
      setup &&
      setup.isFastTrain;

    const baselines = this.getBaselines();

    return retIsContinuous ? (
      this.renderIsContinuous()
    ) : (
      <div
        className={styles.emptyOptimize}
        style={optimized && optimized.isCreating === false ? { paddingBottom: "200px" } : {}}
      >
        <div className={styles.emptyTop}>
          <ProjectHelp
            title={
              isEditBlueprint
                ? "Editing Blueprint: Business Cost Benefits and Labels"
                : "Add Business Assumptions to Optimize the AI Business Impact"
            }
            isDark
            onToggle={(isClosed) => this.setState({ isHelpClosed: isClosed })}
            noBot
          >
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"targetGrey"}>
                {"After Training the AI Aible will show the recommended resourcing, " +
                  "mix, and revenue that optimizes your profit and compares it to the baseline."}
              </ProjectHelpItem>
            )}
            {isEditBlueprint !== true && (
              <ProjectHelpItem isDark type={"rocketGrey"}>
                {"You will be able to keep changing these assumptions even after training the AI."}
              </ProjectHelpItem>
            )}
          </ProjectHelp>
          <div className={styles.eBoxHolder}>
            {isEditBlueprint && false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    value={optimized.resourcingLabel}
                    onChange={(val) => {
                      updateAdvancedCostLabel(runId, val);
                      updateAdvancedCostLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>
                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.totalCost).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.totalCost).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.resourcingLabel,
                        Cost: optimized.totalCost
                      },
                      {
                        label: "Current " + optimized.resourcingLabel,
                        Cost: optimized.currentSpend
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.resourcingLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress("Resourcing")}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Resourcing"}</div>
                <div className={styles.eSubDark}>
                  {"This is your Business Assumptions Costs (the total cost " +
                    "per opportunity) times the Total Opportunities " +
                    "you expect to pursue."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentSpend).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentSpend).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isEditBlueprint ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                {this.renderMix()}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox} style={{ justifyContent: "flex-start" }}>
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator
                    style={{
                      margin: "0px",
                      marginTop: "10px"
                    }}
                    color={"#868595"}
                  />
                </div>
              </div>
            ) : (
              <div
                className={styles.eBox}
                style={{
                  justifyContent: "flex-start",
                  whiteSpace: "wrap"
                }}
              >
                <div className={styles.eDark}>{"Recommended Mix"}</div>
                <div className={styles.eSubDark}>
                  {"Aible will show the optimal resource allocation once the AI has been trained."}
                </div>
              </div>
            )}
            {isEditBlueprint && false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    value={optimized.revenueLabel}
                    onChange={(val) => {
                      updateAdvancedRevenueLabel(runId, val);
                      updateAdvancedRevenueLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>

                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.revenueLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.revenue).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.revenue).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.revenueLabel,
                        Cost: optimized.revenue
                      },
                      {
                        label: "Current " + optimized.revenueLabel,
                        Cost: optimized.currentRevenue
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.revenueLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(optimized.revenueLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Revenue"}</div>
                <div className={styles.eSubDark}>
                  {"This uses your Business Assumption Benefits (expected revenue " +
                    "per opportunitiy) times your Total Expected Win Count."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentRevenue).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentRevenue).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
            {isEditBlueprint && false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>
                  <LineInput
                    isMediumBox
                    isDark
                    value={optimized.profitLabel}
                    onChange={(val) => {
                      updateNetImpactLabel(runId, val);
                      updateNetImpactLabel("new", val);
                    }}
                  />
                </div>
                <div className={styles.eLightLarge}>{"TBD"}</div>
                <div>{"TBD"}</div>
              </div>
            ) : optimized && optimized.isCreating === false ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.profitLabel}</div>
                <div className={styles.eLightLarge}>
                  {optimized.isCurrencyUnitType ? (
                    <div>
                      {unitType}
                      {numeral(optimized.profit).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(optimized.profit).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
                {isSkipped !== true ? (
                  <TinyBarChart
                    bars={[
                      {
                        label: "Optimal " + optimized.profitLabel,
                        Cost: optimized.profit
                      },
                      {
                        label: "Current " + optimized.profitLabel,
                        Cost: optimized.currentProfit
                      }
                    ]}
                    unit={optimized.unitLabel}
                    isCurrencyUnit={optimized.isCurrencyUnitType}
                  />
                ) : (
                  <div>{"Add baseline assumptions to show difference"}</div>
                )}
              </div>
            ) : optimized && optimized.isCreating ? (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{optimized.profitLabel}</div>
                <div className={styles.eLoading}>
                  <LoadingIndicator style={{ margin: "0px" }} color={"#868595"} />
                </div>
                {this.renderProgress(optimized.profitLabel)}
              </div>
            ) : (
              <div className={styles.eBox}>
                <div className={styles.eDark}>{"Baseline Profit"}</div>
                <div className={styles.eSubDark}>
                  {"This is the sum of the unique businesss circumstances you defined" +
                    " in the Costs/Benefits and Expected Win Count across all" +
                    " potential opportunities."}
                </div>
                <div className={styles.eDarkLarge}>
                  {unitType === "$" ? (
                    <div>
                      {unitType}
                      {numeral(currentProfit).format("0.0a")}
                    </div>
                  ) : (
                    <div className={styles.nonC}>
                      {numeral(currentProfit).format("0.0a")}
                      <div className={styles.subLabel}>{unitType}</div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
        {isEditBlueprint ? (
          this.renderEditBlueprintBot()
        ) : (
          <div className={styles.emptyBot}>
            <div className={styles.eBotHeader} style={mSubGroup ? { background: mSubGroup.color } : {}}>
              <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(40% - 40px)" }}>
                {"Business Assumptions"}
              </div>
              <div className={styles.eBotHeaderItem} style={{ minWidth: "calc(30% - 40px)" }}>
                {"Behavior Assumptions"}
              </div>
              <div
                className={styles.eBotHeaderItem}
                style={{
                  minWidth: "calc(30% - 40px)",
                  marginRight: "20px"
                }}
              >
                {"Optimal AI Model"}
                {isOverallSegment !== true && id !== "new" && (
                  <ButtonGroup>
                    <Button
                      onClick={() =>
                        this.setState({
                          isDrivers: true
                        })
                      }
                      active={this.state.isDrivers === true}
                    >
                      {"Drivers"}
                    </Button>
                    <Button
                      onClick={() =>
                        this.setState({
                          isDrivers: false
                        })
                      }
                      active={this.state.isDrivers === false}
                    >
                      {"Charts"}
                    </Button>
                  </ButtonGroup>
                )}
              </div>
            </div>
            <div className={styles.eBotBody}>
              <div className={styles.eBotItem} style={{ minWidth: "calc(40% - 40px)" }}>
                {this.renderAssumptions()}
              </div>
              <div className={styles.eFlex}>
                {optimized ? (
                  <div className={styles.eBotItem} style={{ marginBottom: "20px" }}>
                    <div className={styles.aHeader}>
                      {"Do you have any " + (optimized ? optimized.resourcingLabel : "resourcing") + " constraints?"}
                    </div>
                    <div className={styles.mFlex} style={{ marginTop: "20px" }}>
                      <LineInput
                        isMediumBox
                        labelStyle={{
                          color: "#868595",
                          fontSize: "10px"
                        }}
                        topLabel={"MIN"}
                        onChange={(val) =>
                          setMinBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                        }
                        value={minBudget || minBudget === 0 ? minBudget : "No Minimum"}
                        placeholder={"No Minimum"}
                        style={{ color: "#4B495B" }}
                        forceCommas
                        focusOnClick
                      />
                      <LineInput
                        isMediumBox
                        labelStyle={{
                          color: "#868595",
                          fontSize: "10px"
                        }}
                        topLabel={"MAX"}
                        onChange={(val) =>
                          setMaxBudget(optimized.id, isNaN(val) || val === "" ? undefined : Number(val))
                        }
                        value={maxBudget || maxBudget === 0 ? maxBudget : "No Maximum"}
                        placeholder={"No Maximum"}
                        style={{ color: "#4B495B" }}
                        forceCommas
                        focusOnClick
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div
                  className={styles.eBotItem}
                  style={{
                    padding: "0px"
                  }}
                >
                  {!optimized ? (
                    <div />
                  ) : isOverallSegment === true ? (
                    <div />
                  ) : (
                    <div
                      className={styles.aHeader}
                      style={{
                        borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
                        padding: "20px"
                      }}
                    >
                      <div
                        style={{
                          width: "calc(100% - 75px"
                        }}
                      >
                        {"Will future " +
                          transactionLabel +
                          " and " +
                          outcomeLabel +
                          " rate match the baseline behavior assumptions?"}
                      </div>
                      <div style={{ width: "100px" }}>
                        <div id={"eToggle"} className={styles.tHolder}>
                          <Toggle
                            checked={isRealityHammer === true}
                            icons={false}
                            onChange={(e) => updateIsRealityHammer(runId, !isRealityHammer)}
                          />
                          <span className={isRealityHammer === true ? styles.yPos : styles.nPos}>
                            {isRealityHammer !== true ? "Yes" : "No"}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                  {optimized ? (
                    <div className={styles.wQuestion}>
                      <div className={styles.rHammer}>
                        <span>
                          <span>{"Potential "}</span>
                          <span
                            style={{
                              fontWeight: "bold"
                            }}
                          >
                            {transactionLabel}
                          </span>
                          <span>{" the AI will predict"}</span>
                        </span>
                        <div className={styles.wInput}>
                          <LineInput
                            isMediumBox
                            value={total}
                            isDisabled={isRealityHammer !== true}
                            onChange={(val) => {
                              if (!isNaN(val)) {
                                updateScaledTotal(runId, Number(val));
                              }
                            }}
                            style={{ color: "#4B495B" }}
                          />
                          <div
                            style={{
                              marginRight: "15px"
                            }}
                          >
                            {" with a "}
                          </div>
                          <div style={{ width: "80px" }}>
                            <LineInput
                              isMediumBox
                              value={totalWinRate}
                              isDisabled={isRealityHammer !== true}
                              onChange={(val) => {
                                if (!isNaN(val)) {
                                  updateOutcomePercentage(runId, Number(val) / 100);
                                }
                              }}
                              style={{
                                color: "#4B495B"
                              }}
                            />
                          </div>
                          <div
                            style={{
                              marginLeft: "-6px"
                            }}
                          >
                            {"% " + truePositiveLabel + " rate"}
                          </div>
                        </div>
                      </div>
                      {isRealityHammer === true &&
                        baselines &&
                        baselines.baselineTotal !== undefined &&
                        baselines.baselineTotal !== total && (
                          <div className={styles.overwrote}>
                            {"Original Baseline"}
                            <div className={styles.wInput}>
                              <LineInput
                                isMediumBox
                                value={
                                  baselines && baselines.baselineTotal !== undefined ? baselines.baselineTotal : total
                                }
                                isDisabled={true}
                                onChange={(val) => {
                                  !isNaN(val) && updateScaledTotal(runId, Number(val));
                                }}
                                style={{
                                  color: "#4B495B"
                                }}
                              />
                              <div
                                style={{
                                  marginRight: "15px"
                                }}
                              >
                                {" with a "}
                              </div>
                              <div
                                style={{
                                  width: "80px"
                                }}
                              >
                                <LineInput
                                  isMediumBox
                                  value={
                                    baselines && baselines.baselineWinRate !== undefined
                                      ? baselines.baselineWinRate
                                      : totalWinRate
                                  }
                                  isDisabled={true}
                                  onChange={(val) => {
                                    !isNaN(val) && updateOutcomePercentage(runId, Number(val) / 100);
                                  }}
                                  style={{
                                    color: "#4B495B"
                                  }}
                                />
                              </div>
                              <div
                                style={{
                                  marginLeft: "-6px"
                                }}
                              >
                                {"% " + truePositiveLabel + " rate"}
                              </div>
                            </div>
                          </div>
                        )}
                      {isOverallSegment === true ? (
                        <div
                          style={{
                            marginLeft: "20px",
                            marginBottom: "20px"
                          }}
                        >
                          {"Select a subgroup to update expected behavior"}
                        </div>
                      ) : (
                        <div />
                      )}
                    </div>
                  ) : (
                    <div className={styles.eBotBox} style={{ padding: "20px" }}>
                      <img src={PurpleFlagIcon} className={styles.eIcon} />
                      <div className={styles.eBotBoxBold}>
                        {"Once the AI has been trained this section will allow you " +
                          "to set capacity limits and adjust behavior assumptions."}
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={styles.eBotItem}
                style={{
                  minWidth: "calc(30% - 40px)",
                  marginRight: "20px"
                }}
              >
                {optimized && optimized.isCreating === false && !isOverallSegment ? (
                  <div>
                    <div className={styles.mBold}>
                      <span className={styles.spanLabel}>{"Optimal Model:"}</span>
                      <span>{model ? model.label : "..."}</span>
                    </div>
                    <div className={styles.mRunFrontier}>
                      <RunFrontierContainer id={runId} projectId={id} />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {optimized && optimized.isCreating === false ? (
                  isOverallSegment || isDrivers ? (
                    <div>
                      <div className={styles.aHeader} style={{ marginBottom: "10px" }}>
                        {"Key Drivers"}
                        <PredictionDriverToolTip />
                      </div>
                      <div className={styles.nItemBotContent} style={{ overflow: "auto" }}>
                        {isOverallSegment
                          ? modelGroups.topDrivers.filter((s, i) => i > 0).map((s) => this.renderDrivers(s, 4, false))
                          : this.renderDrivers(
                              (modelGroups.topDrivers || []).find((driver) => driver.runId === optimized.innerId),
                              5,
                              true
                            )}
                      </div>
                    </div>
                  ) : (
                    <div>
                      <div
                        className={styles.runPlot}
                        style={{
                          height: this.state.isHelpClosed ? "37vh" : "30vh"
                        }}
                      >
                        {
                          <RunPlotContainer
                            id={runId}
                            isMiniOptimize
                            projectId={project ? project.id : undefined}
                            forceEnableBts
                            hideFrontier
                          />
                        }
                      </div>
                    </div>
                  )
                ) : (
                  <div className={styles.eBotBox}>
                    <img src={PurpleFlagIcon} className={styles.eIcon} />
                    <div className={styles.eBotBoxBold}>
                      {"Once the AI has been trained this section will " +
                        "display the model that best fits your use case."}
                    </div>
                    <div>
                      {"The optimal model will be based on the cost, benefit, and" +
                        " data assumptions you have defined."}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}
